// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3qd5I","label":"SetPasswdForm_label__3NJdT"};